module.exports = __webpack_public_path__ + "img/icon(20).ebac8ccf.png";